import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as constants from '../common/constants';

/**
 * Navigation convenience methods.
 * Replaces TopCompBase lines 236-303 (toPage* methods).
 *
 * @param {object} options
 * @param {boolean} options.launcher - whether running in launcher mode
 */
const useNavigation = ({ launcher } = {}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const toPageWebAuthnDevices = useCallback(() => {
        navigate(constants.ROUTE_PAGE_WEBAUTHNDEVICES);
    }, [navigate]);

    const toPageWebAuthnRegister = useCallback(() => {
        navigate(constants.ROUTE_PAGE_WEBAUTHNREG);
    }, [navigate]);

    const toPageWebAuthnAuth = useCallback(() => {
        navigate(constants.ROUTE_PAGE_WEBAUTHNAUTH);
    }, [navigate]);

    const toPageUserInfo = useCallback(() => {
        navigate(constants.ROUTE_PAGE_USERINFO);
    }, [navigate]);

    const toPageChangeEmail = useCallback(() => {
        navigate(constants.ROUTE_PAGE_CHANGE_EMAIL);
    }, [navigate]);

    const toPageLogin = useCallback(() => {
        navigate(constants.ROUTE_PAGE_LOGIN);
    }, [navigate]);

    const toPageAuthenticated = useCallback(() => {
        navigate(constants.ROUTE_PAGE_AUTHENTICATED);
    }, [navigate]);

    const toPagePasswordLessSamlSubmit = useCallback(() => {
        navigate(constants.ROUTE_PAGE_PASSWORD_LESS_SAML_SUBMIT);
    }, [navigate]);

    const toPageForgotPassword = useCallback(() => {
        navigate(constants.ROUTE_PAGE_FORGOT_PASSWORD);
    }, [navigate]);

    const toPageChangePassword = useCallback(() => {
        navigate(constants.ROUTE_PAGE_CHANGE_PASSWORD);
    }, [navigate]);

    const toPageTfaHelp = useCallback(() => {
        if (launcher) {
            const win = window.open(
                origin + '/index.html#' + constants.ROUTE_PAGE_TFA_HELP,
                '_blank',
                'noopener,noreferrer'
            );
            if (win) win.opener = null;
            win?.focus();
        } else {
            navigate(constants.ROUTE_PAGE_TFA_HELP);
        }
    }, [navigate, launcher]);

    const toPageTfaRegister = useCallback((verified) => {
        if (typeof verified === 'undefined' || verified === null || verified === true) {
            dispatch({ type: 'USER_CONTACT_VERIFIED', data: true });
        }
        navigate(constants.ROUTE_PAGE_TFA_REGISTER);
    }, [navigate, dispatch]);

    const toPageEmailPasscode = useCallback(() => {
        navigate(constants.ROUTE_PAGE_EMAIL_PASSCODE);
    }, [navigate]);

    const editProfile = useCallback(() => {
        navigate(constants.ROUTE_PAGE_PROFILE);
    }, [navigate]);

    return {
        navigate,
        toPageWebAuthnDevices,
        toPageWebAuthnRegister,
        toPageWebAuthnAuth,
        toPageUserInfo,
        toPageChangeEmail,
        toPageLogin,
        toPageAuthenticated,
        toPagePasswordLessSamlSubmit,
        toPageForgotPassword,
        toPageChangePassword,
        toPageTfaHelp,
        toPageTfaRegister,
        toPageEmailPasscode,
        editProfile,
    };
};

export default useNavigation;
